import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../components/ui/Button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const LoginPage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const isRegisterPage = location.pathname === "/register";

  const handleGoogleLogin = () => {
    setIsLoading(true);
    // CRITICAL: Use dynamic redirect URL to prevent environment mismatches
    const redirectUrl = `${window.location.origin}/dashboard`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_3563a477-4b96-448c-b228-bf27feeae015/artifacts/a3flx1m9_logo-mytharion%20no%20nome.png"
            alt="Mytharion"
            className="w-24 h-24 mx-auto mb-6 opacity-90"
          />
          <h1 className="font-display text-4xl text-gold mb-2" data-testid="auth-title">
            {isRegisterPage ? t("auth.registerTitle") : t("auth.loginTitle")}
          </h1>
          <p className="font-serif-fantasy text-muted-foreground italic">
            {t("auth.quote")}
          </p>
        </div>

        <div className="rune-border bg-card/80 backdrop-blur rounded-lg p-8">
          <Button
            onClick={handleGoogleLogin}
            disabled={isLoading}
            variant="primary"
            size="lg"
            className="w-full mb-6"
            data-testid="auth-google-btn"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin w-5 h-5 border-2 border-black border-t-transparent rounded-full mr-2"></div>
                {t("auth.loading")}
              </div>
            ) : (
              <>
                <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                {t("auth.continueGoogle")}
              </>
            )}
          </Button>

          <div className="divider-fantasy my-6"></div>

          <p className="text-center text-sm text-muted-foreground">
            {isRegisterPage ? (
              <>
                {t("auth.haveAccount")}{" "}
                <Link to="/login" className="text-gold hover:text-gold/80 font-heading">
                  {t("auth.loginCta")}
                </Link>
              </>
            ) : (
              <>
                {t("auth.noAccount")}{" "}
                <Link to="/register" className="text-gold hover:text-gold/80 font-heading">
                  {t("auth.registerCta")}
                </Link>
              </>
            )}
          </p>

          {isRegisterPage && (
            <p className="text-center text-xs text-muted-foreground mt-4 max-w-md mx-auto">
              {t("auth.oauthNote")}
            </p>
          )}
        </div>

        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-muted-foreground hover:text-gold transition-colors">
            {t("common.backHome")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
